export const ide = {
  dependencyListOpen: 'subgraph.dependencies.list.open',
  dependencySave: 'subgraph.dependency.save'
};
